import * as createjs from 'createjs-module';

export class TrimCjStage extends createjs.Stage {
  constructor(canvas: HTMLCanvasElement | string | Object) {
    super(canvas);
    this.enableMouseOver();
  }
}
